// 各种UA判断
export const isApp = /guazi|ganji|GUAGUA|guagua|Guazi|GUAGUAMobile/i.test(window.navigator.userAgent)
export const isJianGuaZi = /Guazi\/jianguazi/i.test(navigator.userAgent)
export const isAndroid = /android/i.test(window.navigator.userAgent)
export const isIOS = /ios/i.test(window.navigator.userAgent)
export const isWeixin = navigator.userAgent.toLowerCase().match(/micromessenger/i)
export const isWeChat = isWeixin
